var map = {
	"./horoscope-icon-0.png": 350,
	"./horoscope-icon-1.png": 351,
	"./horoscope-icon-10.png": 352,
	"./horoscope-icon-11.png": 353,
	"./horoscope-icon-2.png": 354,
	"./horoscope-icon-3.png": 355,
	"./horoscope-icon-4.png": 356,
	"./horoscope-icon-5.png": 357,
	"./horoscope-icon-6.png": 358,
	"./horoscope-icon-7.png": 359,
	"./horoscope-icon-8.png": 360,
	"./horoscope-icon-9.png": 361
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61;


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/horoscopes ^\.\/horoscope\-icon\-.*\.png$
// module id = 61
// module chunks = 0